export default __webpack_public_path__ + "static/media/trainingImage.a83ca56f.png";